/* Endurrad — PRE-ORDINE sulla scheda prodotto (sections/erd-prodotto.liquid). File aggiunto: sopravvive agli aggiornamenti del tema.
   Si accende con il metacampo prodotto custom.preordine (vero) sulle varianti con giacenza 0 e «Continua a vendere quando esaurito».
   Al cambio variante aggiorna: testo dei pulsanti («Pre-ordina»), disponibilità, nota «importo totale / attesa massima»,
   proprietà «Pre-ordine» della riga di carrello e righe di consegna rapida. Gira dopo endurrad-prodotto.js (18/10/2026). */
(function () {
  function q(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function init() {
    var root = document.querySelector('[data-erd-pp]');
    if (!root || !root.hasAttribute('data-erd-pre-on')) return;
    var vJson = root.querySelector('[data-erd-varianti]');
    if (!vJson) return;
    var varianti = [];
    try { varianti = JSON.parse(vJson.textContent); } catch (e) { return; }
    var attesa = root.getAttribute('data-erd-attesa') || 'entro 1 mese';
    function scelte() {
      return q('[data-erd-opts] fieldset', root).map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; });
    }
    function aggiorna() {
      var s = scelte();
      var v = varianti.filter(function (x) { return x.options.every(function (o, i) { return o === s[i]; }); })[0];
      var pre = !!(v && v.pre);
      root.classList.toggle('is-pre', pre);
      q('[data-erd-pre]', root).forEach(function (e) { e.hidden = !pre; });
      q('[data-erd-tag-pre]', root).forEach(function (e) { e.hidden = !pre; });
      q('[data-erd-pre-prop]').forEach(function (e) { e.disabled = !pre; });
      q('[data-erd-cons], [data-erd-veloce]', root).forEach(function (e) { e.hidden = pre; });
      if (!pre) return;
      q('[data-erd-add] .btn-text > span').forEach(function (t) { t.textContent = 'Pre-ordina'; });
      var d = root.querySelector('[data-erd-disp]');
      if (d) {
        d.className = 'erd-pp__s0 is-pre';
        d.innerHTML = '<i aria-hidden="true"></i>';
        d.appendChild(document.createTextNode('Pre-ordine · spedizione ' + attesa));
      }
    }
    q('[data-erd-opt]', root).forEach(function (r) { r.addEventListener('change', aggiorna); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
